module.exports = __webpack_public_path__ + "static/img/20007 (7).ef2b2ea.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20007 (7).webp
// module id = RMVF
// module chunks = 14